<button (click)="darkMode()">darkmode</button>
<ask-button-v2 [disabled]="isDisabled" [selected]="isSelected">
  <app-spinner></app-spinner>
  Teste
</ask-button-v2>

<ask-button-v2 [disabled]="isDisabled" [selected]="isSelected" [shape]="'rounded'" size="larger" appearance="outline">
  <app-icon name="favorite"></app-icon>
  <!-- <app-spinner></app-spinner> -->
</ask-button-v2>

<h1>sizes</h1>
<br />

<button (click)="select()">select</button>
<button (click)="disable()">disable</button>
<button (click)="darkMode()">darkmode</button>

<div class="shape-list">
  <ng-container *ngFor="let shape of shapes">
    <div class="brand-list">
      <div
        *ngFor="let appearance of appearances"
        class="component-list"
        [class.-inverse]="appearance.inverse"
      >
        <span class="appearance"
          >{{ appearance.appearance }}<br />{{ shapes }}</span
        >
        <ng-container *ngFor="let icon of icons">
          <ng-container *ngFor="let size of sizes">
            @if(!(size === 'smallest' && icon !== 'icon')){
            <ask-button-v2
              [appearance]="appearance.appearance"
              [size]="size"
              [shape]="shape"
              [disabled]="isDisabled"
              [selected]="isSelected"
            >
              @if (icon === 'icon-text-icon') {
                <app-icon name="favorite"/>
                Button
                <app-icon name="keyboard_arrow_down"/>
              } @if (icon === 'icon') {
                <app-icon name="favorite"/>
              } @if (icon === 'icon-icon') {
                <app-icon name="favorite"/>
                <app-icon name="keyboard_arrow_down"/>
              }
            </ask-button-v2>
            }
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<br />

<h1>wide</h1>
<div class="large-div">
  <ask-button-v2 [wide]="isWide" (click)="wide()">teste</ask-button-v2>
</div>

<h1>icons</h1>

@for (iconName of iconNames; track $index) {
<div class="icon-list">
  @for (appearance of iconAppearances; track $index) {
    @for (icon of icons; track $index) {
      <ask-button-v2 [disabled]="isDisabled" [selected]="isSelected">
        @if (icon === 'icon') {<app-icon [name]="iconName" [appearance]="appearance" />}
        @if (icon === 'icon-text-icon'){
          <app-icon [name]="iconName" [appearance]="appearance" />
          {{ iconName | titlecase }}
          <app-icon name="keyboard_arrow_down"/>
        }
        @if(icon === 'icon-icon'){
          <app-icon [name]="iconName" [appearance]="appearance" />
          <app-icon name="keyboard_arrow_down"/>
        }
      </ask-button-v2>
    }
  }
</div>
}

<h1>loading</h1>
<ask-button-v2 [appearance]="'brand'" [disabled]="isDisabled" [selected]="isSelected">
  <app-spinner></app-spinner>
</ask-button-v2>
<ask-button-v2 [disabled]="isDisabled" [selected]="isSelected">
  <app-spinner></app-spinner>
  Teste
</ask-button-v2>
<ask-button-v2 [disabled]="isDisabled" [selected]="isSelected">
  <app-spinner></app-spinner>
  Teste
  <app-icon name="whatsapp" appearance="contrast"></app-icon>
</ask-button-v2>

<h1>icones</h1>
<p>icone do material</p>
<app-icon name="home"></app-icon>
<p>icones customizados</p>
<app-icon name="whatsapp"></app-icon>
<app-icon name="whatsapp" appearance="contrast"></app-icon>
<app-icon name="whatsapp" appearance="contrast" theme="dark"></app-icon>
<app-icon name="whatsapp" appearance="contrast" theme="light" [disabled]="true"></app-icon>
<app-icon name="whatsapp" appearance="contrast" theme="light" [disabled]="true" [size]="32"></app-icon>
<app-icon name="whatsapp" appearance="contrast" theme="light" [disabled]="true" [size]="8"></app-icon>

<ask-button-v2>
  <app-icon name="whatsapp" appearance="contrast" theme="light" [disabled]="isDisabled"></app-icon>
</ask-button-v2>

